import { render, staticRenderFns } from "./bidDocument.vue?vue&type=template&id=969ad5b2&scoped=true"
import script from "./bidDocument.vue?vue&type=script&lang=js"
export * from "./bidDocument.vue?vue&type=script&lang=js"
import style0 from "./bidDocument.vue?vue&type=style&index=0&id=969ad5b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969ad5b2",
  null
  
)

export default component.exports